export const FORUM_PALETTE = [
  "#C81E1E",
  "#1D4ED8",
  "#047857",
  "#B45309",
  "#6D28D9",
  "#BE185D",
  "#0E7490",
  "#4D7C0F",
  "#B91C1C",
  "#4338CA",
  "#A16207",
  "#9D174D",
];

export const DEFAULT_NO_FORUM = "#0F766E";

const clean = (hex) => (hex || "").trim();

export const isHex = (hex) => /^#([0-9a-f]{6}|[0-9a-f]{3})$/i.test(clean(hex));

export const rgbOf = (hex) => {
  let value = clean(hex).replace("#", "");
  if (value.length === 3) value = value.split("").map((c) => c + c).join("");
  const int = parseInt(value || "0f766e", 16);
  return [(int >> 16) & 255, (int >> 8) & 255, int & 255];
};

export const alpha = (hex, a) => {
  const [r, g, b] = rgbOf(hex);
  return `rgba(${r}, ${g}, ${b}, ${a})`;
};

export const readableOn = (hex) => {
  const [r, g, b] = rgbOf(hex);
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.62 ? "#0B0B0B" : "#FFFFFF";
};

export const courtColor = (court, index = 0) =>
  isHex(court?.color) ? court.color : FORUM_PALETTE[index % FORUM_PALETTE.length];
